// Single Firebase client SDK initialization. Imported wherever auth/db/storage are needed.
// Wires to local emulators when VITE_USE_EMULATORS=1.
// Single Firebase client SDK initialization. Always points at live services —
// this project does not use emulators.
import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { env } from '../env';

// Strip undefined optional fields so they don't trip exactOptionalPropertyTypes.
const { measurementId, ...required } = env.firebase;
const config = measurementId ? { ...required, measurementId } : required;

const app = getApps()[0] ?? initializeApp(config);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export { app };
